<div class="content-container">
  <div class="slide-container-ii">

    <div class="content-ii">
      <br><br>
      <img class="import-img" src="./assets/images/letterboxd_to_cc.png">
      <br><br><br>
      <p>{{getString('importLetterboxdPage1Text1')}}</p>
      <p>{{getString('importLetterboxdPage1Text2')}}</p>
      <p>{{getString('importLetterboxdPage1Text3')}}</p>
    </div>
    <div class="content-ii">
      <h2>{{getString('stepByStep')}}</h2>
      <p>{{getString('importLetterboxdPage2Text1')}}</p>
      <p>{{getString('importLetterboxdPage2Text2')}}</p>
      <p>{{getString('importLetterboxdPage2Text3')}}</p>
      <!-- Placeholder for Letterboxd export instructions -->
    </div>
    <div class="content-ii">
      <div *ngIf="!isUploading">
        <p>{{getString('importLetterboxdPage3Text1')}}</p>
        <button type="button" (click)="chooseFile()">{{getString('choose')}}</button>
        <span *ngIf="fileOK == true" class="green-text">{{getString('fileOK')}}</span>
        <span *ngIf="invalidFile == true" class="red-text">{{getString('invalidFile')}}</span>
        <span *ngIf="fileTooBig == true" class="red-text">{{getString('fileExceeds128MB')}}</span>
        <input #browseInput type="file" (change)="handleSelectedLocalFiles($event)" class="browse-input" value="Browse">

        <p>{{getString('importLetterboxdPage3Text2')}}</p>
        <div class="inline-block">
          <app-custom-checkbox [value]="iTunesOn" [label]="getString('itunes')" [enabled]="false" (onChange)="cbiTunesChanged($event)"></app-custom-checkbox>
          <app-custom-checkbox [value]="amazonOn" [label]="getString('amazon')" (onChange)="cbAmazonChanged($event)"></app-custom-checkbox>
          <app-custom-checkbox [value]="vuduOn" [label]="getString('vudu')" (onChange)="cbVuduChanged($event)"></app-custom-checkbox>
        </div>
        <p>{{getString('importLetterboxdPage3Text3')}}</p>
        <p>{{getString('importLetterboxdPage3Text4')}}</p>
        <div class="red-text">
          {{errorMessage}}
        </div>
      </div>
      <div *ngIf="isUploading" class="spinner-container">
        <app-spinner></app-spinner>
        <div>{{getString('pleaseWait')}}</div>
      </div>
    </div>
    <div class="content-ii">
      <div *ngIf="uploadSuccessful" class="result-page">
        <h1 class="green-text">{{getString('importSuccessful')}}</h1>
        <p>{{getString('importLetterboxdPage4SuccessText2')}}</p>

        <div *ngIf="importResultDetails" class="import-details">
          <h3>{{getString('Import Details')}}:</h3>
          <div *ngFor="let storeName of getStoreKeys(importResultDetails)" class="store-details">
            <h4>{{getString(storeName) || storeName}}</h4>
            <div class="store-stats">
              <p>{{getString('added')}}: <span>{{importResultDetails![storeName].added}}</span></p>
              <p>{{getString('not added')}}: <span>{{importResultDetails![storeName].notAdded}}</span></p>
              <p>{{getString('already on wishlist')}}: <span>{{importResultDetails![storeName].alreadyAdded}}</span></p>
            </div>
            <div *ngIf="importResultDetails![storeName].notAdded > 0 && importResultDetails![storeName].notAddedTitlesCsv">
              <p class="underlined">{{getString('Titles could not be added')}}:</p>
              <textarea readonly class="not-added-titles-textarea">{{importResultDetails![storeName].notAddedTitlesCsv.split(',').join('\n')}}</textarea>
            </div>
          </div>
        </div>

      </div>
      <div *ngIf="!uploadSuccessful" class="result-page">
        <h1 class="red-text">{{getString('importFailed')}}</h1>
        <p>{{getErrorMessageText()}}</p>
        <p>{{getString('importPage4ErrorText3')}}</p>
      </div>
    </div>

  </div>
  <div class="page-number">{{currentPageNo + 1}}/{{pages.length}}</div>
  <div class="btn-container">
    <button type="button" class="blue-button float-right" (click)="next()" *ngIf="currentPageNo < pages.length - 1 && !isUploading" [disabled]="currentPageNo == 2 && fileOK == false">
      <span *ngIf="currentPageNo != 2">{{getString('next')}}</span>
      <span *ngIf="currentPageNo == 2">{{getString('start')}}</span>
    </button>
    <button type="button" class="blue-button float-right" (click)="close()" *ngIf="currentPageNo == pages.length - 1">
      {{getString('done')}}
    </button>
  </div>

</div>
